module.exports = __webpack_public_path__ + "img/img2.16dadc44.jpg";